<mat-card class="example-card">
  <mat-card-header class="titreFrm ">
    <mat-card-title>INTERLOCUTEUR</mat-card-title>
  </mat-card-header>
  <mat-card-content class="border">
    <div>
      <form class="example-form" #f="ngForm">
        <mat-card class="example-card ">
          <mat-card-content>
            <!------------ bare de chargement ----------------->
            <div *ngIf="exist;else attente"></div>
            <ng-template #attente>
              <mat-progress-bar mode="indeterminate"></mat-progress-bar>
            </ng-template>
            <!------------ bouton ----------------->
            <div class="btn" >
              <div class="button-row">
                  <button (click)="enregistrer(f)" [disabled]="dsabledBtnEnregister" type="submit" mat-raised-button
                class="colorGreen"><mat-icon>save</mat-icon>Enregistrer</button>
              </div>   
              <!-- <div class="button-row">
                <button (click)="close()" mat-raised-button class="colorRed"><mat-icon>close</mat-icon>Fermer</button>
              </div>   -->
            </div>
          
            <!-- ------------------------form interlocuteur--------------------------  -->
            <div>
              <mat-form-field     appearance="outline"  style="margin-right: 10px;width:100px">
                <mat-label>Civilité</mat-label>
                <mat-select name="TiersC_Civilite" #Perso_TypePerso="ngModel"  [(ngModel)]="interlocuteur.TiersC_Civilite" placeholder="Civilité">
                  <mat-option *ngFor="let c of civilites" [value]="c.value">{{c.text}}</mat-option>
                </mat-select>
              </mat-form-field>
              <mat-form-field     appearance="outline"  style="margin-right: 10px;width:225px">
                <mat-label>Nom</mat-label>
                <input matInput [disabled]="disabled" name="TiersC_Nom"
                  (input)="removeNumberFromText(interlocuteur.TiersC_Nom,'TiersC_Nom')"
                  [(ngModel)]="interlocuteur.TiersC_Nom" placeholder="Nom" required>
              </mat-form-field>
              <mat-form-field     appearance="outline"  style="margin-right: 10px;width:225px">
                <mat-label>Prénom</mat-label>
                <input matInput [disabled]="disabled" name="TiersC_PreNom"
                  (input)="removeNumberFromText(interlocuteur.TiersC_PreNom,'TiersC_PreNom')"
                  [(ngModel)]="interlocuteur.TiersC_PreNom" placeholder="Prénom" required>
              </mat-form-field>
            </div>
          <div>
              <mat-form-field     appearance="outline"  style="margin-right: 10px;width:275px">
                <mat-label>Sérvice</mat-label>
              <input matInput [disabled]="disabled" name="TiersC_Service"
                (input)="removeNumberFromText(interlocuteur.TiersC_Service,'TiersC_Service')"
                [(ngModel)]="interlocuteur.TiersC_Service" placeholder="Sérvice" >
            </mat-form-field>
            <mat-form-field     appearance="outline"  style="margin-right: 10px;width:275px">
              <mat-label>Fonction</mat-label>
              <input matInput [disabled]="disabled" name="TiersC_Fonction"
                (input)="removeNumberFromText(interlocuteur.TiersC_Fonction,'TiersC_Fonction')"
                [(ngModel)]="interlocuteur.TiersC_Fonction" placeholder="Fonction" >
            </mat-form-field>
            
          </div>
          <div>
            <mat-form-field     appearance="outline"  style="margin-right: 10px;width:250px">
              <mat-label>E-mail</mat-label>
              <input matInput [disabled]="disabled" name="TiersC_Mail"
                [(ngModel)]="interlocuteur.TiersC_Mail" placeholder="E-mail" >
            </mat-form-field>
              <mat-form-field     appearance="outline"  style="margin-right: 10px;width:150px">
                <mat-label>Mobile</mat-label>
              <input matInput [disabled]="disabled" name="TiersC_Mobile" type="number"
                [(ngModel)]="interlocuteur.TiersC_Mobile" placeholder="Mobile" >
            </mat-form-field>
            <mat-form-field     appearance="outline"  style="width:150px">
              <mat-label>Fixe</mat-label>
              <input matInput [disabled]="disabled" name="TiersC_Tel" type="number"
                [(ngModel)]="interlocuteur.TiersC_Tel" placeholder="Fixe" >
            </mat-form-field>
          </div>
          
          </mat-card-content>
        </mat-card>
      </form>
    </div>
  </mat-card-content>
</mat-card>